import React, {useEffect, useState} from 'react'
import {Layout} from "../components";
import styles from "../styles/Home.module.scss"
import numbers from "../images/number.svg"
import arrowDown from "../icons/arrow.svg"
import whatWeDo from "../images/what_we_do.png"
import optimizeTech from "../images/optimizeTech.png";
import finance from "../icons/finance.svg"
import globe from "../icons/globe.svg"
import engineering from "../icons/engineering.svg"
import marketing from "../icons/marketing.svg"
import security from "../icons/security.svg"
import arrowLeft from "../icons/arrow-left.svg"
import vision from "../icons/vision.svg"
//import lineage_explaination from "../images/lineage_explaination.png"
import stars from "../icons/stars.svg"
import understanding_data from "../icons/understanddata.svg"
import understanding_data_2 from "../icons/understandData_2.svg"
import health_safety from "../icons/health_and_safety.svg"
import education from "../icons/education.svg"
import compass from "../clients/Tata-CLiQ-Logo.png"
import ebay from "../clients/mfcwl.png"
import dropbox from "../clients/cnb.svg"
import gartner from "../clients/qurix.svg"
import twilio from "../clients/digitalabs.svg"
import lazboy from "../clients/aimex.png"
import arch_consultancy from "../images/arch_consultancy.png"
import {useWindowSize} from "../utility/useLayoutEffect";

const companies = [{id:'compass', logo: compass},{id:'ebay', logo: ebay},{id:'dropbox', logo: dropbox},{id:'gartner', logo: gartner},{id:'twilio', logo: twilio}, {id:'lazboy', logo: lazboy}]
const primaryFeatures = [{id: 1, feature: 'Business', image: globe, display: false},
    {id: 2, feature: 'Education', image: education, display: true},
    {id: 3, feature: 'Engineering', image: engineering,  display: true},
    {id: 4, feature: 'Finance', image: finance,  display: true},
    {id: 5, feature: 'Health', image: health_safety,  display: true},
    {id: 6, feature: 'Marketing', image: marketing, display: true},
    {id: 7, feature: 'Security', image: security, display: false},
]

const Home = () => {

    const [width] = useWindowSize();

    const [features, setFeatures] = useState();

    useEffect(() => {
        if (typeof window !== 'undefined' && features === undefined && width !== 0) {
            window.scrollTo(0,0);
            setFeatures(width > 700 ? primaryFeatures.slice(1, 6) : primaryFeatures.slice(2, 5));
        }
    }, [setFeatures, features, width])

    /*const onChange = (e) =>{
    }
    const onClickItem = (e) =>{
    }
    const onClickThumb = (e) =>{

    }*/
    return (<Layout classes={styles.body}>
        <section className={styles.banner}>
            <div className={styles.imageLeft}>
                <img src={numbers} alt=""/>
            </div>
            <div className={styles.bannerContainer}>
                <div className={styles.bannerInner}>
                    <div className={styles.bannerItem1}>
                        <h1>
                            Unlocking Your Business Potential</h1>
                    </div>
                    <div className={styles.bannerItem2}>
                        <p>
                            At Cosmoneural, we are dedicated to helping businesses thrive in today's dynamic landscape. As a premier consulting and product development company, we bring together expertise, innovation, and collaboration to drive your success.
                            <br/>
                            <br/>
                        </p>
                        {/*<p>Talk to us to know how we can help you manage complexities adeptly.</p>*/}
                    </div>
                    <button onClick={() => window.location.href= 'contactus' }>
                        Let's Speak
                    </button>
                </div>
            </div>
            <div className={styles.imageRight}>
                <img src={numbers} alt=""/>
            </div>
        </section>
        <div className={styles.arrowContainer} onClick={() => document.getElementById("intuitive_products").scrollIntoView()}>
            <div className={styles.arrowDown}>
                <img src={arrowDown} alt="down arrow"/>
            </div>
        </div>

        {/*<Carousel showArrows={true} onChange={onChange} onClickItem={onClickItem} onClickThumb={onClickThumb}/>*/}
        <div className={styles.companiesContainer}>
            <div className={styles.companiesSubContainer}>
                <h4>Trusted By Companies Across a Diverse Range of Industries</h4>
                <div className={styles.companyList}>
                    {companies.map((company, index) => (
                        <div>
                            <img src={company.logo} alt={company.id}/>
                        </div>
                    ))}
                </div>
            </div>
        </div>
        <div className={styles.goals}>
            <div className={styles.goalsInner}>
                <div className={styles.goalsItem1}>
                    <img src={whatWeDo} alt='what we do'/>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h3>What We Do
                        </h3>
                        <p>
                            As a premier consulting and product development company, we bring together expertise, innovation, and collaboration to drive your success.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className={styles.platform}>
            <h3>
                Why Choose Cosmoneural?
            </h3>
            <div className={styles.platformInner}>
                <div className={styles.platformItems}>
                    <div className={styles.image}>
                        <img className={styles.icon} src={vision} alt='data mapping'/>
                    </div>
                    <div className={styles.content}>
                        <h5>
                            Proven Track Record
                        </h5>
                        <p>We have a history of delivering exceptional results for businesses across diverse industries. Our satisfied clients are a testament to our ability to drive growth and exceed expectations. Our leadership team comprises industry experts and visionaries who are passionate about driving innovation and shaping the future of businesses. Their strategic guidance and industry insights ensure that we remain at the forefront of industry trends.</p>

                    </div>
                </div>
                <div className={styles.platformItems}>
                    <div className={styles.image}>
                        <img className={styles.icon} src={understanding_data} alt='understand data'/>
                    </div>
                    <div className={styles.content}>
                        <h5>
                            Customized Solutions
                        </h5>
                        <p>We understand that each business is unique. That's why we tailor our solutions to fit your specific needs. Whether you require strategic guidance, market research, product design, or comprehensive consulting services, our customized approach addresses your challenges and maximizes your potential.</p>
                    </div>
                </div>
                <div className={styles.platformItems}>
                    <div className={styles.image}>
                        <img className={styles.icon} src={understanding_data_2} alt='understand data'/>
                    </div>
                    <div className={styles.content}>
                        <h5>
                            Results-Driven Approach
                        </h5>
                        <p>We are committed to delivering tangible results that make a real impact on your bottom line. Through a combination of expertise, innovation, and data-driven strategies, we help you achieve your business objectives.</p>
                    </div>
                </div>

            </div>

        </div>

        <button className={styles.contactUs} onClick={() => window.location.href= 'contactus' }>
            Contact Us
        </button>

        <div className={styles.goals}>
            <div className={`${styles.goalsInner} ${styles.reverse}`}>
                <div className={`${styles.goalsItem1} ${styles.reverse}`}>
                    <img src={optimizeTech} alt='optimize tech'/>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h3>Optimizing technology to
                            reduce complexity
                        </h3>
                        <p>
                            Today’s demands require an architecture that is highly scalable, agile, flexible, and cloud-ready.

                            Whether you could use some expertise for fine-tuning your current architecture, or you need assistance with a complete overhaul, we’re here to help.

                            Our team of experienced Enterprise Architects, strategists, designers, and builders help companies navigate the chaos, improve performance, and achieve their visions.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        {/* <div className={styles.goals}>

            <div className={`${styles.goalsInner} ${styles.reverse}`} style={{background: 'transparent'}}>
                <div className={styles.goalsItem1}>
                    <div className={styles.content}>
                        <img src={gear}/>
                        <h6>Real-Time Interaction</h6>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                    </div>
                    <div className={styles.content}>
                        <img src={secure_data}/>
                        <h6>Advanced Annotations</h6>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                    </div>
                    <div className={styles.content}>
                        <img src={aiml}/>
                        <h6>Manage Your Datasets</h6>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. </p>
                    </div>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h5>Accelerate the development of your AI applications.</h5>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </p>
                    </div>

                </div>
            </div>
        </div>*/}
         {/*<div className={styles.goals}>

            <div className={styles.goalsInner}>
                <div className={styles.goalsItem1}>
                    <img src={lineage_explaination}/>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h5>We Are you Partners throughout your cloud journey
                        </h5>
                        <p>
                            We help you design and implement an optimal architecture for the cloud to meet your current and future needs leveraging proven frameworks, best practices, and leading technologies.

                            Whether you could use some expertise for fine-tuning your current architecture, or you need assistance with a complete overhaul, we’re here to help.

                            Our team of experienced Enterprise Architects, strategists, designers, and builders help companies navigate the chaos, improve performance, and achieve their visions.
                        </p>
                    </div>
                </div>
            </div>

        </div>*/}

        <h3>
            Our Approach
        </h3>
        <div className={styles.goals}>
            <div className={`${styles.goalsInner}`}>
                <div className={styles.goalsItem1}>
                    <img src={arch_consultancy} alt='consultancy'/>
                </div>
                <div className={styles.goalsItem2}>
                    <div className={styles.content}>
                        <h5>Consulting Excellence</h5>
                        <p>Our seasoned consultants work closely with you to understand your unique challenges, identify opportunities, and develop strategies aligned with your business goals. We provide valuable insights and data-driven recommendations to guide your decision-making process.
                        </p>
                    </div>
                    <div className={styles.content}>
                        <h5>Product Development Expertise</h5>
                        <p>From concept to market, our product development team excels in transforming your ideas into exceptional products. Leveraging the latest technologies and industry best practices, we create innovative and user-centric solutions that captivate your target audience.
                        </p>
                    </div>
                    <div className={styles.content}>
                        <h5>Innovation at the Core</h5>
                        <p>Innovation is the fuel that propels businesses forward. At Cosmoneural, we embrace emerging trends, technologies, and disruptive ideas to keep you ahead of the competition. Our innovative solutions and forward-thinking approach empower you to adapt, innovate, and seize new opportunities.
                        </p>
                    </div>
                    <div className={styles.content}>
                        <h5>Collaborative Partnership</h5>
                        <p>We believe in building strong, collaborative partnerships with our clients. Our team becomes an extension of yours, working closely with your stakeholders to ensure seamless integration of our expertise into your business operations. Open communication, trust, and transparency are the cornerstones of our collaborative approach.
                        </p>
                    </div>
                </div>
            </div>
        </div>


        <div id="intuitive_products" className={styles.features}>
            <h3>Intuitive Products</h3>
            <p>We follow data-driven design principles to build intelligent products that allow businesses to make smart decisions and build resilience by harnessing the power of technology. With problem-solving and learning capabilities built into them, all our applications are contextual — created with the needs and user-experience of our end-users in mind. As a result, our products enable you to gather and leverage deep insights and advanced analytics to meet domain-related challenges head-on and to stay ahead of the curve.</p>
            <div className={styles.featureItemContainer}>
                <div className={styles.featureItemList}>
                <span className={styles.arrow} onClick={() =>{

                    if(primaryFeatures.findIndex(feature => feature.id === features[0].id) !== 0)
                    {   features.splice(features.length -1, 1);
                        features.splice(0, 0, primaryFeatures[primaryFeatures.findIndex(feature => feature.id === features[0].id) -1] )
                    }
                    setFeatures([...features]);
                }}>
                    <img src={arrowLeft} alt='left arrow'/>
                </span>
                    <div className={styles.featureItems}>
                        {features && features.map((feature, index) =>(
                            <span key={index} className={styles.feature}>
                <img style={{height: "50%", width: "50%",}} src={feature.image} alt={feature.feature}/>
                <p>{feature.feature}</p>
                    </span>
                        ))}
                    </div>
                    <span className={styles.arrowRight} onClick={() => {

                        if (primaryFeatures.findIndex(feature => feature.id === features[features.length - 1].id) !== primaryFeatures.length - 1) {
                            features.splice(0, 1);
                            features.push(primaryFeatures[primaryFeatures.findIndex(feature => feature.id === features[features.length - 1].id) + 1]);
                        }
                        setFeatures([...features]);
                    }}>
                    <img src={arrowLeft} alt={'arrowleft'}/></span>
                </div>
            </div>
        </div>
        <section style={{width: '100%', display: 'flex', flexDirection: 'column', justifyContent:"center", alignItems:"center"}}>
            <h3>We prioritise data safety management.</h3>
            <div className={styles.cardListing}>
                <div className={styles.card}>
                    <div className={styles.details}>
                        <h5>Data privacy and security</h5>
                        <p>We use the most reliable systems, guidelines and technologies to protect your data from
                            theft, damage, loss or unauthorised access. All our offerings have appropriate controls to
                            ensure that your information's privacy and security is never compromised.
                        </p>
                    </div>
                </div>
                <div className={styles.card}>
                    <div className={styles.details}>
                        <h5>Data controller and data processor</h5>
                        <p>When you avail of any of our products, you are responsible for the data you collect through
                            it. As the Data Controller, you decide the purpose for which the information is collected
                            and used. For all the solutions we provide, we, Cosmoneural, are the Data Processor unless
                            stated otherwise.</p>
                    </div>
                </div>
            </div>
        </section>
        <div className={styles.rating}>
            <h4>“The best experience I’ve ever had.”</h4>
            <div className={styles.ratingInner}>
                <div className={styles.user}>
                    <span className={styles.number}>
                        4.9/5
                    </span>
                    <span className={styles.image}>
                        <img src="https://media.licdn.com/dms/image/C5603AQHduOBH54795A/profile-displayphoto-shrink_100_100/0/1607837810338?e=1690416000&v=beta&t=rSyXUaPBH_PEXL5nhOjgY4YJEsp2T87y17EChLw2dgA" alt={'user profile pic'}/>
                    </span>
                    <span className={styles.name}>
                    Ananth
                </span>
                </div>
                <div className={styles.content}>
                    <h6>Cosmoneural was phenomenal!</h6>
                    <p>
                        I had the opportunity to work with Abhay for a short period. During this time, I observed that he was very quick in grasping business and product requirements, understanding the as-is and magnitude of change involved. As he is strong in his fundamentals, he simplifies the problems and comes up with a good, scalable solution using the right kind of technology that is required. He is someone who is hands-on and always has the big picture in mind. I look forward to working with him again.
                    </p>
                    <img alt={'stars'} style={{width:"180px", height:"31px", marginTop:"20px"}} src={stars}/>
                </div>
            </div>
            <div style={{display: 'flex',width: "100%", marginTop:"20px",justifyContent: 'center', alignItems: 'center'}}>
                    <span style={{padding: "15px", height:"41px", width: "42px", display: "flex", justifyContent: "center", alignItems:"center", border: "1.5px solid #F0F0F0", boxSizing: "border-box"}}>
                    <img alt={'arrowleft'} src={arrowLeft}/>
                </span>
                <span style={{transform: "rotate(180deg)",padding: "15px", height:"41px", width: "42px",display: "flex", marginLeft: '20px',justifyContent: "center", alignItems:"center",border: "1.5px solid #F0F0F0", boxSizing: "border-box"}}>
                    <img alt={'arrowright'} src={arrowLeft}/></span>
            </div>
        </div>
        <div className={styles.demo}>
            <div className={styles.sendContainer}>
                <h5>How may we help you?</h5>
                {/*<div className={styles.send}><input type='email'/> <span> <img src={send} alt={"send"}/> </span></div>*/}
                <div className={styles.buttonContainer}>
                    <button className={styles.contactUs} onClick={() => window.location.href= 'contactus' }>
                        Cosmoneural products
                    </button>
                    <button className={styles.contactUs} style={{marginLeft: '20px'}} onClick={() => window.location.href= 'contactus' }>
                        EA consultancy services
                    </button>
                </div>
            </div>
        </div>

    </Layout>)
}

export default Home;
